// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__URTLC","main1":"Layout_main1__QJFhV","show-menu":"Layout_show-menu__nu0GS","left-panel":"Layout_left-panel__-A0BQ","right-panel":"Layout_right-panel__M3meB"};